import React from 'react';
import { get } from 'lodash';

import { convertToParagraphs } from '../../helpers/format';
import Text from '../../components/Text';
import Link from '../../components/Link';
import Spacer from '../../components/Spacer';
import Editor from '../../components/Editor';
import LazyLoad from '../../components/Lazyload';
import DialogBox from '../../components/DialogBox';
import Background from '../../components/Background';

import style from "./style.module.css";

const GameClosedView = ({ closedContent, openingScreenContent }) => {
    return (
        <DialogBox
            fullscreen
            modalClassName="gameClosed"
            render={() => {
                return (
                    <LazyLoad className={style.popupWrap}>
                        <div className={style.content}>
                            <div className={style.images}>
                                <Background src={get(closedContent, "image")} normalImage alt="William start screen" />
                                <Background src={get(closedContent, "text_image")} normalImage className={style.wheresWilliamTextImage} alt="Where's William" />
                            </div>
                            <div className={style.textWrap}>
                                <Spacer size='64' />
                                <div className={style.textWrap}>
                                    <Editor text={convertToParagraphs(get(closedContent, "text"))} />
                                </div>
                                <Spacer size='48' />
                                <Text className="size40">
                                    <Link className="link underlined" to={get(closedContent, "button_link", '/')}>
                                        {get(closedContent, "button")}
                                    </Link>
                                </Text>
                            </div>
                        </div>
                    </LazyLoad>
                )
            }}
        />
    )
}

export default GameClosedView;